export default __webpack_public_path__ + "media/images/wide_white_channel_logo-a1d652002753971e189c2cac9956d497.svg";